import { PurchasingLabelTemplateDTO } from "@/dto/template/PurchasingLabelTemplateDTO";
import httpClient from "@/services/http/mainServerClient";

/** 获取当前店铺的拿货标签模板列表 */
export function getPurchasingLabelTemplateList(): Promise<PurchasingLabelTemplateDTO[]> {
    return httpClient.get(`/purchasingLabelTemplate`);
}

interface CreateTemplateParams {
    name: string;
    width: number;
    height: number;
    picture?: Blob;
}

// 新增拿货标签模板
export function createPurchasingLabelTemplate(params: CreateTemplateParams) {
    const formData = new FormData();

    Object.entries(params).forEach(([key, value]) => {
        if (value) {
            formData.append(key, value);
        }
    });

    return httpClient.post(`/purchasingLabelTemplate`, formData, { timeout: 60000 });
}

interface CreateTemplateByQnParams {
    name: string;
    width: number;
    height: number;
    pictureFileSize?: number;
    pictureOriginalName?: string;
    pictureUrl?: string;
}

export function createPurchasingLabelTemplateByQn(params: CreateTemplateByQnParams) {
    return httpClient.post("/purchasingLabelTemplate/qianniu/purchaingLabelTemplate", params);
}

// 修改拿货标签模板
export function updatePurchasingLabelTemplate(
    id: number,
    params: Omit<PurchasingLabelTemplateDTO, "fields" | "height" | "name" | "offsetLeft" | "offsetTop" | "width">,
) {
    return httpClient.post(`/purchasingLabelTemplate/update/${id}`, params);
}

// 删除拿货标签模板
export function deletePurchasingLabelTemplate(id: number) {
    return httpClient.post(`/purchasingLabelTemplate/delete/${id}`);
}

// 绑定打印机
export function bindPurchasingLabelTemplatePrinter({ templateId, printer }) {
    return httpClient.post(`/purchasingLabelTemplate/${templateId}:bindPrinter`, {
        printer,
    });
}

// 解绑打印机
export function unbindPurchasingLabelTemplatePrinter(templateId: number) {
    return httpClient.post(`/purchasingLabelTemplate/${templateId}:unbindPrinter`);
}

// 绑定店铺
export function bindPurchasingLabelTemplateShop({ templateId, shopIds }) {
    return httpClient.post(`/purchasingLabelTemplate/${templateId}:bindShop`, {
        shopIds,
    });
}

// 解绑店铺
export function unbindPurchasingLabelTemplateShop(templateId: number) {
    return httpClient.post(`/purchasingLabelTemplate/${templateId}:unbindShop`);
}

// 复制当前模板
export function copyPurchasingLabelTemplate(templateId: number) {
    return httpClient.post(`/purchasingLabelTemplate/${templateId}:copy`);
}

// 复制系统模板
export function copyPurchasingLabelSystemTemplate(templateId: number) {
    return httpClient.post(`/purchasingLabelTemplate/${templateId}:copySystem`);
}

// 获取系统模板
export function getPurchasingLabelSystemTemplates(): Promise<PurchasingLabelTemplateDTO[]> {
    return httpClient.get(`/purchasingLabelTemplate/system`);
}
